import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UserService } from '../../../app/services/user.service';
import { AdminService } from "./../../services/admin.service";
import { AutoWithdrawService } from "./../../services/autowithdraw.service";
const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-addautowithdrawal',
    templateUrl: './addautowithdrawal.component.html',
    styleUrls: ['./addautowithdrawal.component.css']
})
export class AddAutoWithdrawal {
    element: any = {};
    whitelistedAddress: any = [];
    users: any[] = [];
    myForm: any = FormControl;
    dropdownSettings = {};
    selectedItems: any = [];
    selectedItemIds: string[] = [];

    constructor(
        public dialogRef: MatDialogRef<AddAutoWithdrawal>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private notifSer: NotificationsService,
        public fb: FormBuilder,
        public userService: UserService,
        public adminService: AdminService,
        private autoWithdrawService: AutoWithdrawService,
    ) {
        this.getUserForDropdown();
        this.element = data;
        this.myForm = this.fb.group({
            userid: ['', [Validators.required]],
            address: ['', [Validators.required]],
            amount: ['', [Validators.required, Validators.min(0.00001)]],
            min_transfer_quantity: ['', [Validators.required, Validators.min(0.00001)]],
            rate: ['', [Validators.required, Validators.min(0.00001)]],
            note: ['', []],

        });
        this.userService.csrf().subscribe((response) => {
            this.data['_csrf'] = response._csrf; 
        });

        this.dropdownSettings = {
            singleSelection: true,
            text: 'Select User',
            itemsShowLimit: 1,
            enableSearchFilter: true,
            classes: 'myclass custom-class'
        };
    }

    onItemSelect(item: any) {
        this.myForm.get('userid').setValue(item.id);
        this.getWhitelistAddresses();

    }
    OnItemDeSelect() {
        this.myForm.get('userid').setValue('');
    }
    getUserForDropdown() {
        this.userService.getUserForDropdown().subscribe(users => {
            this.users = users.map(item => {
                return {
                    id: item._id,
                    itemName: item.name
                }
            });;
        })
    }

    getWhitelistAddresses() {
        if (!this.myForm.value['userid']) {
            return this.notifSer.error('Error', 'Please select user');
        }
        this.userService.csrf().subscribe((success) => {
            this.adminService.WithdrawWhitelist(0, 0, this.myForm.value['userid'], success['_csrf']).subscribe(whitelistedAddresses => {
                this.whitelistedAddress = whitelistedAddresses.addresslist;
            })
        });
    }
    // Save Form to database
    saveExchangeWithdrawal() {
        const { notif } = defaults
        if (this.element) {
            if (!this.myForm.value['userid']) {
                return this.notifSer.error('Error', 'Please fill the User', notif);
            }
            if (!this.myForm.value['address']) {
                return this.notifSer.error('Error', 'Please select Address', notif);
            }
            if (!this.myForm.value['amount']) {
                return this.notifSer.error('Error', 'Please fill the Amount', notif);
            }
            this.userService.csrf().subscribe(success => {
                this.myForm.value._csrf = success['_csrf'];
                var whitelistedAddres = this.whitelistedAddress.find(
                    e => (e._id == this.myForm.value['address']));

                const { currency,address,assetid,blockchain } = whitelistedAddres;
                const result = {...this.myForm.value,currency,address,assetid,blockchain }

                this.autoWithdrawService.saveAutoWithdraw(result).subscribe(response => {
                    if (response) {
                        if (response.status) {
                            this.notifSer.success('Success', response.message, notif)
                            // Emit the form data when closing the dialog
                            this.dialogRef.close({ success: true, data: response.message });
                        } else this.notifSer.error('Error', response.message, notif);
                    } else this.notifSer.error('Error', response.message, notif);
                });
            })

        }
    }

}


// WEBPACK FOOTER //
// ./src/app/autowithdrawal/addautowithdrawal/addautowithdrawal.component.ts